<template>
  <div class="broadcast-item" @click="openBroadcastList">
    <div class="broadcast-avatar">
      <i class="el-icon-message-solid"></i>
    </div>
    <div class="broadcast-main">
      <div class="broadcast-title-row">
        <span class="broadcast-title">系统通知</span>
        <span class="broadcast-tag">广播</span>
      </div>
      <div class="broadcast-desc">{{ previewText }}</div>
    </div>
    <div class="broadcast-meta">
      <span class="broadcast-time">{{ formatTime(latest.releaseTime) }}</span>
      <span class="unread-dot"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BroadcastItem",
  props: {
    broadcastData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    latest() {
      return this.broadcastData[0] || {};
    },
    previewText() {
      return this.getPlainText(this.latest.content) || this.latest.title || "暂无系统通知";
    }
  },
  methods: {
    openBroadcastList() {
      this.$router.push("/home/broadcast");
    },
    formatTime(timeStr) {
      if (!timeStr) return "";
      const date = new Date(timeStr);
      const now = new Date();
      const diff = now - date;
      if (Number.isNaN(date.getTime())) return "";
      if (diff < 60000) return "刚刚";
      if (diff < 3600000) return `${Math.floor(diff / 60000)}分钟前`;
      if (diff < 86400000) return `${Math.floor(diff / 3600000)}小时前`;
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    },
    getPlainText(htmlContent) {
      if (!htmlContent) return "";
      let text = String(htmlContent)
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&apos;/g, "'")
        .replace(/\s+/g, " ")
        .trim();
      return text.length > 50 ? `${text.substring(0, 50)}...` : text;
    }
  }
};
</script>

<style scoped lang="scss">
.broadcast-item {
  min-height: 60px;
  display: flex;
  align-items: center;
  margin: 2px 4px;
  padding: 8px 10px;
  border-radius: 10px;
  background: #fff7ed;
  cursor: pointer;
  transition: background-color 0.16s ease, transform 0.12s ease;

  &:hover {
    background: #ffedd5;
    transform: translateY(-1px);
  }
}

.broadcast-avatar {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #f59e0b;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 22px;
}

.broadcast-main {
  flex: 1;
  min-width: 0;
  padding-left: 10px;
}

.broadcast-title-row {
  display: flex;
  align-items: center;
  height: 20px;
  line-height: 20px;
}

.broadcast-title {
  font-size: var(--im-font-size);
  color: #111827;
  font-weight: 600;
}

.broadcast-tag {
  margin-left: 6px;
  padding: 1px 6px;
  border-radius: 10px;
  background: #f97316;
  color: #ffffff;
  font-size: 11px;
  line-height: 16px;
}

.broadcast-desc {
  margin-top: 2px;
  font-size: var(--im-font-size-small);
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.broadcast-meta {
  min-width: 48px;
  margin-left: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
}

.broadcast-time {
  font-size: var(--im-font-size-smaller);
  color: #9ca3af;
  line-height: 18px;
}

.unread-dot {
  width: 8px;
  height: 8px;
  margin-top: 6px;
  border-radius: 50%;
  background: #f56c6c;
}
</style>
